import { useContext } from 'react';
import {
    Typography, Card, CardContent, TablePagination, Table, useTheme,
    TableHead, TableBody, TableRow, TableCell, makeStyles, Theme,
} from '@material-ui/core';
import { vitecUsersContext as vitecUsersContext } from '../VitecUsersContext';
import { appUserContext } from 'helpers/services';
import { CircleLoader, DeleteIconButton, EditIconButton } from 'components';


let useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: theme.spacing(3)
    },
    content: {
        padding: 0
    }
}))

let Results = () => {
    let theme = useTheme();
    let classes = useStyles(theme);

    let { currentUser } = useContext(appUserContext);
    let service = useContext(vitecUsersContext);


    return (
        <div className={classes.root}>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <>
                    <Typography color="textSecondary" gutterBottom>
                        {service.recordCount} users found
                    </Typography>
                    <Card>
                        <CardContent className={classes.content}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Company</TableCell>
                                        <TableCell>Countries</TableCell>
                                        <TablePagination
                                            count={service.recordCount}
                                            onPageChange={service.handleChangePage}
                                            page={service.search.pageNr}
                                            rowsPerPage={service.search.pageSize}
                                            rowsPerPageOptions={[service.search.pageSize]}
                                            labelDisplayedRows={({ page, count }) =>
                                                <span>Page {page + 1} of {Math.ceil(count / service.search.pageSize)}</span>
                                            }
                                        />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {service.vitecUsers.map((user, index) => (
                                        <TableRow hover key={index}>
                                            <TableCell>{user.email}</TableCell>
                                            <TableCell>{user.firstName}&nbsp;{user.lastName}</TableCell>
                                            <TableCell>{user.companyName}</TableCell>
                                            <TableCell>{user.countries.join(", ")}</TableCell>
                                            <TableCell align="right">
                                                <EditIconButton link={`/admin/videndumuser/edit/${user.id}`} />
                                                {user.email !== currentUser?.email &&
                                                    <DeleteIconButton onClick={() => service.deleteVitecUser(user.id)} />
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                component="div"
                                count={service.recordCount}
                                onPageChange={service.handleChangePage}
                                page={service.search.pageNr}
                                rowsPerPage={service.search.pageSize}
                                rowsPerPageOptions={[service.search.pageSize]}
                                labelDisplayedRows={({ page, count }) =>
                                    <span>Page {page + 1} of {Math.ceil(count / service.search.pageSize)}</span>
                                }
                            />
                        </CardContent>
                    </Card>
                </>
            }
        </div>
    )
}

export default Results;